/* INPUT: "24-02-2022" | OUTPUT: "2022-02-24" */

export const dateToISO8601 = (date = '') => {
  return date.split('-').reverse().join('-');
};
